// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__2BIQu","message":"ErrorMessage_message__mm9A_"};